// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { makeObservable, observable } from 'mobx';
import { OrderSummaryDTO } from './order-summary';

export interface HotspotItemDTO {
  orderId: number;
  order: string;
  customerId: number;
  customer: string;
  assets: OrderSummaryDTO;
  scheduled: OrderSummaryDTO;
  collected: OrderSummaryDTO;
  processed: OrderSummaryDTO;
  delivered: OrderSummaryDTO;
  dueDate: string;
  statusSummaryString?: string;
  // Data to show when node is expanded.
  // details: HotspotDetailDTO[];
}

// similar to HotspotItemDTO but with slightly different field names.
export interface HotspotItemAPIDTO {
  id: number;
  orderNumber: string;
  orderName: string;
  customerName: string;
  customerId: number;
  dueDate: string;
  notes: string;
  statusSummaryString: string;
}

export default class HotspotItem {
  orderId: number;
  @observable order: string;
  customerId: number;
  @observable customer: string;
  @observable assets: OrderSummaryDTO;
  @observable scheduled: OrderSummaryDTO;
  @observable collected: OrderSummaryDTO;
  @observable processed: OrderSummaryDTO;
  @observable delivered: OrderSummaryDTO;
  @observable dueDate: string;
  @observable statusSummaryString: string;

  constructor(dto: Partial<HotspotItemDTO>) {
    this.update(dto);
    makeObservable(this);
  }

  get asJson(): HotspotItemDTO {
    
    return {
      orderId: this.orderId,
      order: this.order,
      customerId: this.customerId,
      customer: this.customer,
      assets: this.assets,
      scheduled: this.scheduled,
      collected: this.collected,
      processed: this.processed,
      delivered: this.delivered,
      dueDate: this.dueDate,
      statusSummaryString: this.statusSummaryString,
    };
  }

  update(newData: Partial<HotspotItemDTO>): HotspotItemDTO {
    const allData = { ...this.asJson, ...newData }; // merge new data to existing data.  New data does not need to be complete (Partial).

    Object.assign(this, allData);

    return this.asJson;
  }
}
